export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const UNSEND_NOTIFICATIONS_REQUEST = "UNSEND_NOTIFICATIONS_REQUEST";
export const ADD_NOTIFICATION_REQUEST = "ADD_NOTIFICATION_REQUEST";
